module.exports = __webpack_public_path__ + "media/images/2015_Homepage_1024_Transparent-aefac7d0aadb17f57e89578ca2e62d48.png";